import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, initializeMsal } from "./msalInstance.js";
import AuthGate from "./AuthGate.jsx";
import { clearDrills, drillIdFrom } from "./utils/drillHandoff";

// Report drill handoffs hold deal filters: drop any left from earlier
// sessions, keeping only the one this tab was opened to pick up.
clearDrills({ keep: drillIdFrom(window.location.search) });

initializeMsal().then(() => {
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthGate>
          <App />
        </AuthGate>
      </MsalProvider>
    </StrictMode>
  );
});
